export enum AUTH_SCREEN_NAME {
  INITIAL = 'initial',
  OTP = 'otp',
  CONSENTS = 'consents',
}
